import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "~redux/store";
import { Story } from "~types/types";

interface transporterState {
    currentSlug: string;
    hasTransported: boolean;
}

const initialState: transporterState = {
    currentSlug: "",
    hasTransported: false,
};

const transporterSlice = createSlice({
    name: "transporter",
    initialState,
    reducers: {
        updateCurrentSlug(state, action: PayloadAction<Story>) {
            const story = action.payload;

            return {
                currentSlug: story.slug,
                hasTransported: story.slug !== state.currentSlug,
            };
        },
    },
});

export const { updateCurrentSlug } = transporterSlice.actions;

export const selectCurrentSlug = (state: RootState) =>
    state.transporter.currentSlug;

export const selectHasTransported = (state: RootState) =>
    state.transporter.hasTransported;

export default transporterSlice.reducer;
